module.exports = __webpack_public_path__ + "img/file-audio.fb4cec29.svg";